import buyerPortalService from '@/services/buyer-portal';

export default {
  methods: {
    async bpHealthCheck(isSendNotification = false) {
      try {
        const result = await buyerPortalService.healthCheck({
          isSendNotification
        });

        if (result.data.message === 'BP_SERVICE_UNAVAILABLE') {
          this.$router.push({
            name: 'top-page',
            query: this.$route.query,
          });
          return false;
        }
        
        return true;
      } catch (error) {
        return true;
      }
    },
  }
}; 